import * as yup from 'yup'
import { VALIDATION_PATTERNS } from '../../config'

export const dataFileValidationSchema = yup.object().shape({
  fileName: yup
    .string()
    .required('Filename is required')
    .max(250, 'The file name is too long, maximum number of characters is 255.')
    .matches(VALIDATION_PATTERNS.DATA_FILE_NAME, 'Invalid filename format'),
  title: yup
    .string()
    .trim()
    .max(
      246,
      'The file title is too long, maximum number of characters is 246.'
    ),
  requests: yup.array().of(
    yup.object().shape({
      instrument: yup.string().trim().required('Instrument is required'),
    })
  ),
})
